import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import theme from '@ep/theme';
import { Gcms_RichText } from '@ep/types/gatsbyTypes';
import getHtmlProp from '@ep/utils/getHtmlProp';
import isExpired from '@ep/utils/isExpired';
import React from 'react';

export interface ColorProps {
  hex: string;
}

export interface FlexBannerModuleProps {
  content: Gcms_RichText;
  textColor: ColorProps;
  backgroundColor: ColorProps;
  scrollToLink: string;
  expirationDateTime: string;
  show: boolean
}

const StyledContainer = styled(Container)`
  padding: 1rem;
  text-align: center;
  max-width: 100%;
  h6 {
    font-weight: normal;
    margin: 0rem;
  }
  img {
    max-width: 10rem;
  }
  blockquote {
    color: inherit;
  }
  a {
    color: inherit;
    text-decoration: underline;
    cursor: pointer;
  }
  ${theme.mediaQueries.mobileAndTablet} {
    padding: 1rem;
  }
`;

const StyledContent = styled('div')`
  width: 100%;
  font-size: 1.4rem;
  min-height: 2.5rem;
  ${theme.mediaQueries.mobileAndTablet} {
    text-align: center;
  }
`;

const StyledDiv = styled('div')`
  width: 80%;
  margin: auto auto;
  ${theme.mediaQueries.mobileAndTablet} {
    margin: auto auto;
    width: 100%;
  }
`;

function FlexBannerModule({
  content,
  textColor,
  backgroundColor,
  scrollToLink,
  expirationDateTime,
  show,
}: FlexBannerModuleProps) {
  const injectedContent = content.html.replace(
    /<a /g,
    '<a onClick="dataLayer.push({ event: \'Flex Banner link clicked\'});" ',
  );

  return (
    <>
      {(show === true) ? ((expirationDateTime === null || isExpired(expirationDateTime) === false) ? (
        <StyledContainer
          backgroundColor={backgroundColor.hex}
          id={scrollToLink}
        >
          <StyledDiv>
            <StyledContent
              {...getHtmlProp(injectedContent)}
              style={
                textColor?.hex ? { color: textColor.hex } : { color: '#FFFFFF' }
              }
            />
          </StyledDiv>
        </StyledContainer>
      ) : null): null}
    </>
  );
}
export default React.memo(FlexBannerModule);
